import type { components } from '../../api/generated/schema';
import type { Member, MembershipChecklist } from '../../domain/audience';
import { toCollectionRef, toPersonRef } from '../mapping';

type S = components['schemas'];

export function toMember(m: S['Member']): Member {
  return { person: toPersonRef(m.person), role: m.role };
}

export function toMembershipChecklist(c: S['MembershipChecklist']): MembershipChecklist {
  return {
    person: toPersonRef(c.person),
    collections: c.collections.map((x) => ({
      collection: toCollectionRef(x.collection),
      checked: x.checked,
    })),
  };
}
